﻿export default class SubmitRequestButton {
    constructor() {
      this.id = 'submitRequestButton';
    }
  
    getHtml() {
      const styles = 'class="btn btn--blue btn--width-100 btn--64-xl loading"';
      return `<button id="${this.id}" data-qa="submit-request-button" ${styles}>Submit Request</button>`;
    }
  
    getNode() {
      return document.getElementById(this.id);
    }
  }
  